<template>
  <li
    ref="menuItemRef"
    v-clickout="closeTrigger"
    :class="['gfr-menu-item', asTrigger && 'gfr-menu-item--trigger group', 'data-[state=open]:text-primary']"
    :data-state="triggerOpen ? 'open' : 'close'"
    @click="hoverTrigger"
  >
    <slot />
  </li>
</template>
<script lang="ts" setup>
const route = useRoute()
const props = defineProps({
  asTrigger: Boolean
})
const menuItemRef = ref<HTMLElement>()
const triggerOpen = ref(false)
function hoverTrigger() {
  if (menuItemRef.value && props.asTrigger) {
    triggerOpen.value = !triggerOpen.value
  }
}
function closeTrigger() {
  if (menuItemRef.value && props.asTrigger) {
    triggerOpen.value = false
  }
}
// watch(
//   () => route.params,
//   () => {
//     hoverTrigger()
//   }
// )
</script>
